"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ManifestoAbout() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="manifestoabout" className="py-24 overflow-hidden !bg-[hsl(20,100%,98%)] lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={sectionRef} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative aspect-[4/5] lg:aspect-square rounded-3xl overflow-hidden shadow-xl">
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[#E67E5D]/10 rounded-lg -z-10" />
            <div className="absolute -bottom-10 -left-10 w-24 h-24 bg-[#E67E5D]/5 rounded-lg -z-20" />
            <img src="https://connectedonline.nl/wp-content/uploads/2026/05/byjasminfotografie-139-scaled.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631459/img/screenshot-1778069675261.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631459/img/screenshot-1778069675261.png-wvc-sizes" alt="Team Connected Online in overleg" className="object-cover w-full h-full transition-transform duration-700 hover:scale-105" loading="lazy" />
          </div>

          {}
          <div className="flex flex-col gap-6 lg:pr-8">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground leading-[1.1] tracking-tight">Alles wat aandacht krijgt&nbsp;<span className="!text-[hsl(250,75%,67%)]" data-ast-id="f:/src/pages/Home/sections/ManifestoAbout.tsx|sig:aqw4r6" data-ast-start="1561" data-ast-end="1730">groeit&nbsp;</span>net als jouw online marketing</h2>
            
            <div className="space-y-6 text-lg text-muted-foreground font-default leading-relaxed">
              <p className="!font-light">Van advertenties tot automatiseringen: als je alle losse onderdelen binnen online marketing goed op elkaar afstemt, dan gaat je business pas echt groeien.</p>
              <p className="!font-light">Connected Online is niet zomaar een online marketingbureau, het is in feite de online marketingafdeling van je bedrijf. In deze online wereld focussen we op jouw onderneming, jouw doelen en jouw tempo. Dat leidt tot meer zichtbaarheid, tijdswinst en structurele groei. Jouw onderneming is uniek, jouw klanten ook. Dus waarom zou jouw online strategie dat niet zijn? Wij zetten AI slim in waar het werkt en bouwen aan een online podium die niet alleen vandaag sterk is, maar ook toekomstproof is.</p>
            </div>

            <div className="pt-6">
              <Button asChild size="lg" className="rounded-lg px-8 h-12 text-base">
                <Link to="#">Ontdek onze werkwijze</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}